<template>
  <v-layout pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10 md9 lg9 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>
              Edit Driver
              <b>{{ user.name }}</b>
            </h2>
          </v-flex>
          <v-flex xs12 pl-1>
            <h3>User</h3>
          </v-flex>
          <v-flex xs12 md12>
            <UserForm
              ref="userForm"
              :disabled="false"
              :user="user"
              :errors="errors.user"
              :editingUser="true"
              @validityChange="updateFormValidity('user', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Driver</h3>
          </v-flex>
          <v-flex xs12 md12>
            <DriverForm
              ref="driverForm"
              :driver="driver"
              :driver_details="driver_details"
              :errors="driverErrors"
              :currentDocuments="currentDriverDocuments"
              :pictureUrl="pictureUrl"
              @imageInput="handleImageInput"
              @documentInput="handleDocumentInput"
              @validityChange="updateFormValidity('driver', $event)"
              @deletePicture="handleDeletePicture"
              @deleteDocument="handleDeleteDocument"
              @viewDocument="handleViewDocument"
            />
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Taxi</h3>
          </v-flex>
          <v-flex xs12 md12>
            <SelectTaxi :taxi="taxi" @taxiChange="handleTaxiChange" />
          </v-flex>
          <v-flex xs12 md12>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="update" class="text-none">Update</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/driver/UserForm.vue";
import DriverForm from "@/components/driver/DriverForm.vue";
import SelectTaxi from "@/components/driver/SelectTaxi.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_driver",
  components: {
    SimpleCard,
    UserForm,
    DriverForm,
    SelectTaxi
  },
  data: function() {
    return {
      loading: false,
      user: {},
      driver: {},
      driver_details: {},
      taxi: {},
      currentDriverDocuments: [],
      pictureUrl: "",
      rideTypes: [],
      councils: [],
      errors: {},
      userFormValid: false,
      driverFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  mounted: function() {
    this.getTaxiInformation();
    this.getDriverInfo();
  },
  methods: {
    getTaxiInformation: async function() {
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {}
        });
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    getDriverInfo: async function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/${this.$route.params.id}/getForEdit`;

      axios
        .get(url)
        .then(function(response) {
          if (!response.error) {
            self.populateDriverInfo(response.data);
          } else {
            console.log(response.error);
            //handle error
          }
        })
        .catch(function(error) {
          console.log(error);
          //handle error
        });
    },
    populateDriverInfo: function(data) {
      console.log(data);
      let newDriver = {
        callsign: data.driver.callsign,
        driving_license_number: data.driver.licence_number,
        hackney_number: data.driver.hackney_number,
        private_hire_number: data.driver.hire_number,
        driving_license_expiry: data.driver.licence_number_renewal_date,
        hackney_expiry: data.driver.hackney_number_renewal_date,
        private_hire_expiry: data.driver.hire_number_renewal_date,
        fee_percentage: data.driver.fee_percentage,
        picture: data.pictureURL,
        documents: []
      };

      let newDriverDetails = {
        address_line_1: data.driver_details.address1,
        address_line_2: data.driver_details.address2,
        town: data.driver_details.town,
        county: data.driver_details.county,
        postcode: data.driver_details.postcode,
        home_phone: data.driver_details.homeNumber,
        b_tech: data.driver_details.btech,
        wheelchair_cert: data.driver_details.wheelChairCertificate,
        nvq: data.driver_details.nvq,
        adt: data.driver_details.adt
      };

      let newUser = {
        name: data.driver.user.name,
        email: data.driver.user.email,
        contact_number: data.driver.user.contact_number,
        password: ""
      };

      this.driver = newDriver;
      this.driver_details = newDriverDetails;
      this.user = newUser;
      this.currentDriverDocuments = data.documents;
      this.pictureUrl = data.pictureURL;
      this.taxi = data.taxi;
    },
    updateFormValidity: function(form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "driver":
          this.driverFormValid = value;
          break;
      }
    },
    handleImageInput: function(file) {
      this.driver.picture = file;
    },
    handleDocumentInput: function(files) {
      this.driver.documents = files;
    },
    handleDeletePicture: function() {
      this.pictureUrl = "";
    },
    handleDeleteDocument: function(fileID) {
      console.log(fileID);
      this.currentDriverDocuments = this.currentDriverDocuments.filter(function(
        document
      ) {
        return document.id !== fileID;
      });
    },
    handleViewDocument: function(fileID) {
      let documentFile = this.currentDriverDocuments.find(function(document) {
        return document.id === fileID;
      });

      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/getDocumentUrl`;
      axios({
        url: url,
        method: "GET",
        params: {
          key: documentFile.filename
        }
      })
        .then(function(response) {
          if (response.data.error) {
            console.log(response.data.error);
            self.snackbarMessage = "Failed to retrieve file";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.setAttribute("download", documentFile.name);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function(error) {
          console.log(error);
          self.snackbarMessage = "Failed to retrieve file";
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
    },
    handleTaxiChange: function(newTaxi) {
      this.taxi = newTaxi;
    },
    update: async function() {
      if (this.userFormValid && this.driverFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/driver/${this.$route.params.id}/update`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: this.driver,
            driver_details: this.driver_details,
            taxiID: this.taxi.id,
            pictureUrl: this.pictureUrl,
            currentDocuments: this.currentDriverDocuments
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error updating driver, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error updating driver: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const driverID = response.data.driver.id;
              self.$router.push("../../driver/view/" + driverID);
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.driverForm.validateForm();
      }
    }
  },
  computed: {
    driverErrors: function() {
      return {
        ...this.errors.driver,
        ...this.errors.driver_details
      };
    }
  }
};
</script>